import {v1_UsersStatus_select_column} from '../../generated/types';

const UserStatus = {
    ...v1_UsersStatus_select_column,
    res: 'v1_UsersStatus',
    comp: {},
    rel: {},
};

export default UserStatus;
